var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-cinza btn-block text-uppercase no-print",attrs:{"id":"print-button","title":"Imprimir","disabled":_vm.disabled},on:{"click":function($event){return _vm.imprimir()}}},[_c('font-awesome-icon',{attrs:{"icon":"print"}}),_vm._v(" Imprimir ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }